"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.createRefinePlanTool = createRefinePlanTool;
const fs = __importStar(require("fs-extra"));
const dist_1 = require("../../../fs/dist");
const refinePlan_1 = require("../../../app/dist/refinePlan");
const samplingAiClient_1 = require("../samplingAiClient");
const refineContext_1 = require("./refineContext");
const toolDef = {
    name: 'loom_refine_plan',
    description: 'Refine an existing Loom plan document using MCP sampling. Re-evaluates steps, sharpens descriptions, bumps version.',
    inputSchema: {
        type: 'object',
        properties: {
            id: { type: 'string', description: 'Plan document id to refine' },
            context_ids: { type: 'array', items: { type: 'string' }, description: 'Optional. Additional doc IDs to inject as extra context before refining.' },
        },
        required: ['id'],
    },
};
function createRefinePlanTool(server) {
    return {
        toolDef,
        async handle(root, args) {
            const id = args['id'];
            const contextIds = Array.isArray(args['context_ids']) ? args['context_ids'] : [];
            // Primary (agent-supplied) id → suggest-on-miss.
            const { id: canonicalId, filePath } = await (0, dist_1.resolveDocIdOrThrow)(root, id);
            // Inject the thread's Unified Context bundle (locked req first) plus any
            // caller context_ids, so refine is req-aware. IO stays in the mcp layer.
            const extraContext = await (0, refineContext_1.buildRefineExtraContext)(root, canonicalId, contextIds);
            const result = await (0, refinePlan_1.refinePlan)({ filePath, extraContext }, { loadDoc: dist_1.loadDoc, saveDoc: dist_1.saveDoc, aiClient: (0, samplingAiClient_1.samplingAiClient)(server), fs });
            return { content: [{ type: 'text', text: JSON.stringify(result) }] };
        },
    };
}
